class NSSTabsGroup extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.els = {};

    this.enableAutoswitch = "false";
    this.autoswitchDelay = 3000;
    this.autoswitchPause = false;
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Tabs Group] Connected.`);

    this.init();

    this.initAutoplay();

    this.addEventListener(`click`, this.handleClick.bind(this));
    this.addEventListener(`mouseenter`, this.handleMouseEnter.bind(this));
    this.addEventListener(`mouseleave`, this.handleMouseLeave.bind(this));

    const editorEvents = [
      `shopify:inspector:activate`,
      `shopify:inspector:deactivate`,
      `shopify:section:load`,
      `shopify:section:unload`,
      `shopify:section:select`,
      `shopify:section:deselect`,
      `shopify:section:reorder`,
      `shopify:block:select`,
      `shopify:block:deselect`,
    ];
    editorEvents.forEach((event) => {
      this.addEventListener(event, this.handleEditorEvent.bind(this));
    });
  }

  init() {
    this.els.controlScroll = this.querySelector(`.nss-tabs-controls__scroll-wrapper`);
    this.els.controls = this.querySelectorAll(`nss-tab-control`);
    this.els.groups = this.querySelectorAll(`nss-tab-group`);

    this.enableAutoswitch = this.getAttribute(`nss-enable-autoswitch`);
    this.autoswitchDelay = this.getAttribute(`nss-autoswitch-delay`);

    if (this.els.controls[0]) {
      const wrapperEl = this.els.controls[0].querySelector(`.nss-tab-control__wrapper`);
      this.applyExternalContent(wrapperEl);
      this.applyLinkedCopy(wrapperEl);
    }
  }

  initAutoplay() {
    if (this.enableAutoswitch === "false") return;

    if (this.debug) console.log(`[NSS][Tabs Group] this.enableAutoswitch:`, this.enableAutoswitch);
    if (this.debug) console.log(`[NSS][Tabs Group] this.autoswitchDelay:`, this.autoswitchDelay);

    let current = 0;
    let max = this.els.controls.length;
    // let scrollOptions = {
    //   behavior: "smooth",
    //   block: "center",
    //   inline: "center",
    //   container: "nearest",
    // };

    setInterval(() => {
      if (this.autoswitchPause) return;

      current += 1;
      if (current == max) current = 0;

      /**
       * Safari doesn't support 'container' in scrollIntoView's options. This
       * means it effects every scroll container, causing the entire page to
       * scroll to this element at every call.
       */
      // this.els.controls[current].scrollIntoView(scrollOptions);

      this.scrollActiveControlIntoView(this.els.controls[current]);
      const id = this.els.controls[current].getAttribute(`nss-tab-control-id`);
      this.selectTabByControlId(id, { scrollControl: false });
    }, this.autoswitchDelay);
  }

  handleEditorEvent(e) {
    if (this.debug) console.log(`[NSS][Tabs Group] Handle editor event, e:`, e);

    switch (e.type) {
      case `shopify:block:select`:
        if (e.detail.blockId === this.getAttribute(`data-block-id`)) return;

        const markedEl = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
        if (!markedEl) return;

        const controlEl = markedEl.closest(`nss-tab-control`);
        if (controlEl && this.contains(controlEl)) {
          const id = controlEl.getAttribute(`nss-tab-control-id`);
          if (id != null) {
            this.selectTabByControlId(id, { scrollControl: true });
          }
          return;
        }

        const groupEl = markedEl.closest(`nss-tab-group`);
        if (groupEl && this.contains(groupEl)) {
          const id = groupEl.getAttribute(`nss-tab-group-id`);
          if (id != null) {
            this.selectTabByControlId(id, { scrollControl: true });
          }
        }
        break;
    }
  }

  selectTabByControlId(id, options = {}) {
    const controlEl = this.querySelector(`nss-tab-control[nss-tab-control-id="${id}"]`);
    const groupEl = this.querySelector(`nss-tab-group[nss-tab-group-id="${id}"]`);
    if (!controlEl || !groupEl) return;

    this.els.controls.forEach((c) => c.classList.remove(`nss-active`));
    this.els.groups.forEach((g) => g.classList.remove(`nss-active`));

    const cardEls = groupEl.querySelectorAll(`.nss-card-product__wrapper`);
    cardEls.forEach((cardEl) => cardEl.classList.remove(`nss-has-hovered`));

    controlEl.classList.add(`nss-active`);
    groupEl.classList.add(`nss-active`);

    const wrapperEl = controlEl.querySelector(`.nss-tab-control__wrapper`);
    if (wrapperEl) {
      this.applyExternalContent(wrapperEl);
      this.applyLinkedCopy(wrapperEl);
    }

    this.updateAllCarousels();
    this.stopAllVideos();

    if (options.scrollControl) {
      this.scrollActiveControlIntoView(controlEl);
    }
  }

  scrollActiveControlIntoView(controlEl) {
    const scrollEl = this.els.controlScroll;
    if (!scrollEl || !controlEl) return;

    const scrollRect = scrollEl.getBoundingClientRect();
    const rect = controlEl.getBoundingClientRect();
    const x = controlEl.offsetLeft;
    const newLeft = x - scrollRect.width / 2 + rect.width / 2;

    scrollEl.scrollTo({
      behavior: `smooth`,
      top: 0,
      left: newLeft,
    });
  }

  handleClick(e) {
    const controlEl = e.target.closest(`nss-tab-control`);
    if (!controlEl || !this.contains(controlEl)) return;

    const id = controlEl.getAttribute(`nss-tab-control-id`);
    if (id == null) return;

    this.selectTabByControlId(id, { scrollControl: false });
  }

  handleMouseEnter(e) {
    this.autoswitchPause = true;
  }

  handleMouseLeave(e) {
    this.autoswitchPause = false;
  }

  applyExternalContent(wrapperEl) {
    const externalSettings = wrapperEl.getAttribute(`nss-external-settings`);
    if (externalSettings === "true") {
      const extId = wrapperEl.getAttribute(`nss-external-target-id`);
      const extColorBg = wrapperEl.getAttribute(`nss-external-color-bg`);
      const extColorText = wrapperEl.getAttribute(`nss-external-color-text`);
      const extImageBg = wrapperEl.getAttribute(`nss-external-image-bg`);
      const extVideoBg = wrapperEl.getAttribute(`nss-external-video-bg`);

      const extEl =
        document.querySelector(`#${extId}`) ||
        document.querySelector(`[data-block-id$="${extId}" i]`);
      if (extEl) {
        extEl.style.backgroundColor = extColorBg;
        extEl.style.color = extColorText;

        const imgEl = extEl.querySelector(`img`);
        const hasVideo = this.applyExternalVideo(extEl, extVideoBg);
        if (hasVideo) {
          extEl.style.backgroundImage = ``;
          if (imgEl) imgEl.style.visibility = `hidden`;
        } else {
          if (imgEl) imgEl.style.visibility = ``;
          if (extImageBg) {
            if (imgEl) {
              imgEl.removeAttribute(`srcset`);
              imgEl.removeAttribute(`sizes`);
              imgEl.src = extImageBg;
            } else {
              extEl.style.backgroundImage = `url('${extImageBg}')`;
            }
          }
        }
      }
    }
  }

  applyExternalVideo(extEl, src) {
    let holderEl = extEl.querySelector(`:scope > .nss-tabs-group__external-video`);

    if (!src) {
      if (holderEl) holderEl.remove();
      return false;
    }

    if (!holderEl) {
      holderEl = document.createElement(`div`);
      holderEl.className = `nss-tabs-group__external-video`;
      holderEl.setAttribute(`aria-hidden`, `true`);

      const videoEl = document.createElement(`video`);
      videoEl.autoplay = true;
      videoEl.loop = true;
      videoEl.muted = true;
      videoEl.playsInline = true;
      videoEl.setAttribute(`playsinline`, ``);
      videoEl.setAttribute(`preload`, `metadata`);
      videoEl.setAttribute(`no-stop`, `true`);

      holderEl.appendChild(videoEl);
      extEl.prepend(holderEl);
    }

    const videoEl = holderEl.querySelector(`video`);
    if (videoEl.getAttribute(`src`) !== src) {
      videoEl.setAttribute(`src`, src);
    }
    videoEl.muted = true;
    const playPromise = videoEl.play();
    if (playPromise) playPromise.catch(() => {});

    if (getComputedStyle(extEl).position === `static`) {
      extEl.style.position = `relative`;
    }

    return true;
  }

  applyLinkedCopy(wrapperEl) {
    if (!wrapperEl) return;

    const swap = (idAttr, textAttr) => {
      const idSuffix = wrapperEl.getAttribute(idAttr);
      const text = wrapperEl.getAttribute(textAttr);
      if (!idSuffix || text == null) return;
      document.querySelectorAll(`[data-block-id$="${idSuffix}"]`).forEach((el) => {
        el.textContent = text;
      });
    };

    swap(`nss-link-heading-id`, `nss-link-heading`);
    swap(`nss-link-body-id`, `nss-link-body`);
  }

  updateAllCarousels() {
    const carouselEls = this.querySelectorAll(`nss-carousel`);

    carouselEls.forEach((carouselEl) => {
      carouselEl.swiper.update();
    });
  }

  stopAllVideos() {
    const videoEls = this.querySelectorAll(`video`);

    videoEls.forEach((videoEl) => {
      if (videoEl.getAttribute(`no-stop`) === "true") return;
      videoEl.pause();
      videoEl.muted = true;
      videoEl.parentElement.setAttribute(`nss-video-playing`, false);
    });
  }
}

let elementName = `nss-tabs-group`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSTabsGroup);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
